<script>
   /*************************************************************/
   /* ModelTable                                                */
   /* -------------------------                                 */
   /* shows table with PCA outcomes for training set            */
   /*************************************************************/

   // main properties of the whole app
   let { resobj } = $props();

   const NCOMPMAX = 16;
   const cumexpvar = $derived(resobj ? resobj.stat.cumexpvar : null);
   const expvar = $derived(resobj ? resobj.stat.expvar : null);
   const eigenvals = $derived(resobj ? resobj.eigenvals.map(v => v * (resobj.nrows - 1)) : null);
</script>


{#if resobj}
<table>
   <thead>
   <tr>
      <th>PC</th>
      <th>Expvar</th>
      <th>Cumexpvar</th>
      <th>Eigenvals</th>
   </tr>
   </thead>
   <tbody>
   {#each resobj.stat.components.filter(v => v < NCOMPMAX) as a}
   <tr>
      <td>{a}</td>
      <td>{(expvar[a - 1] * 100).toFixed(2)}</td>
      <td>{(cumexpvar[a - 1] * 100).toFixed(2)}</td>
      <td>{(eigenvals[a - 1]).toFixed(2)}</td>
   </tr>
   {/each}

   {#if resobj.ncomp > NCOMPMAX}
   <tr>
      <td>...</td>
      <td>...</td>
      <td>...</td>
      <td>...</td>
   </tr>
   {/if}

   {#if resobj.ncomp >= NCOMPMAX}
   <tr>
      <td>{resobj.ncomp}</td>
      <td>{((cumexpvar[resobj.ncomp - 1] - cumexpvar[resobj.ncomp - 2]) * 100).toFixed(2)}</td>
      <td>{(cumexpvar[resobj.ncomp - 1] * 100).toFixed(2)}</td>
      <td>{(eigenvals[resobj.ncomp - 1]).toFixed(2)}</td>
   </tr>
   {/if}
   </tbody>
   </table>
{/if}

<style>
   table {
      width: 100%;
      border-collapse: collapse;
   }

   tr {
      width: 100%;
   }

   th {
      border-bottom: 1px solid #a0a0a0;
   }

   th, td {
      text-align: right;
      padding: 0.2em 0.5em 0.2em 0.1em;
      color: #404040;
      margin: 0;
   }
</style>